// extracted by mini-css-extract-plugin
module.exports = {"inner":"VideosListForSingleVideo-module--inner--18zxR","wrap":"VideosListForSingleVideo-module--wrap--2Bysl"};